import { useContext, createContext, useSyncExternalStore } from 'react';

const Context = createContext(null);

export const { Provider } = Context;

export const useMfeHostStore = () => {
  const { subscribe, snapshot, mutate, ...mutators } = useContext(Context);

  return { mutate, mutators, snapshot: useSyncExternalStore(subscribe, snapshot) };
};
